import React from 'react';
import { FormattedMessage } from 'react-intl';

export const orders = 'orders';
export const items = 'items';
export const itemGroupByOptions = [orders, items];

export const GroupByOptionToFriendlyNameMap = {
  [orders]: <FormattedMessage defaultMessage='Orders' description='item.groupBy.orders' id='3sK5Z9' />,
  [items]: <FormattedMessage defaultMessage='Items' description='item.groupBy.items' id='MHwAsO' />,
};
